/*eslint-disable*/
import {commonApi} from '@/common/index'

const bankcardList = {
  data () {
    return {
      picLink: '',
      bankList: ''
    }
  },
  methods: {
    checkBankCard (arr) {
      if(arr.length>0) {
        arr.forEach((item) => {
          item['picUrl'] = `${this.picLink}banks/${item.bankCode}.png`
        })
        this.bankList = arr
      }else {
        this.bankList = []
      }
    },
    resetBankListInfo() {
      commonApi.PAY.bankCardList()
        .then(data => {
          this.checkBankCard(data)
        })
        .catch(err => {})
    },
    getBankListInfo() {
      commonApi.HOMEBEFORE.serverInfo()
        .then(link => {
          this.picLink = link;
          return commonApi.PAY.bankCardList()
        })
        .then(data => {
          this.checkBankCard(data)
        })
        .catch(err => {})
    }
  },
  mounted () {
    this.getBankListInfo()
  }
}

export default bankcardList



// WEBPACK FOOTER //
// ./src/common/mixins/bankcard/bankcardList.js